import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loadingCard is-loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "image group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-50 overflow-hidden" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "col-span-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImagesComparison = _resolveComponent("ImagesComparison")!
  const _component_ArrowDownTrayIcon = _resolveComponent("ArrowDownTrayIcon")!
  const _component_CameraItemLayout = _resolveComponent("CameraItemLayout")!
  const _component_NavigationComponent = _resolveComponent("NavigationComponent")!

  return (_openBlock(), _createBlock(_component_NavigationComponent, {
    activeTag: _ctx.$t('app_features.compare')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CameraItemLayout, { noData: _ctx.noData }, {
        contentLeft: _withCtx(() => [
          (!_ctx.noData && _ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
          (!_ctx.noData && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_ImagesComparison, {
                  onNoData: _cache[0] || (_cache[0] = ($event: any) => (_ctx.noData = true)),
                  camera: _ctx.cameraId,
                  onBeforeChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.beforeDate = $event)),
                  onAfterChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.afterDate = $event))
                }, null, 8, ["camera"])
              ]))
            : _createCommentVNode("", true)
        ]),
        contentRight: _withCtx(() => [
          (!_ctx.noData && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadImages())),
                class: "animated-button mr-2 rounded-md border border-yellow focus:border-yellow text-sm text-yellow shadow-sm hover:bg-yellow hover:text-white"
              }, [
                _createVNode(_component_ArrowDownTrayIcon, { class: "m-0 box-border block h-6 w-full shrink-0" }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("buttons.download_image_range")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["noData"])
    ]),
    _: 1
  }, 8, ["activeTag"]))
}